import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from 'components/nubox/NuDropdown';

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";
import ModalTema from './ModalTema'

import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';

const data = [
  //{ id_medico: 1,  nombre: 'ALEX LIZARRAGA',  especialidad: '00000023',tel:''}, 
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class TemaList extends React.Component {  

  modalRef = React.createRef();//create ref
  
  state = {
    modalInsertar: false,
    form: {
      t_key: '',
    },
    data: data,/* lista de datos */
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    this.setState({data:[]});

    this.cargar_data();
    
    //this.cargar_citas();
    console.log(this.modalRef);
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  //====================================================== 
  cargar_data = () => {
    let materia = this.props.store.materia
    let user = this.props.store.user

    let param = { 
      t_key: this.state.form.t_key,
      id_mate: materia.id_mate,
      id_peri: user.id_peri
    }
    
    axios2.post( 'tema_get_list', param)
    .then(res => {
        console.log(res.data);
        if(res.data.length>0){ 
            this.setState({data: res.data});
        }else{
            NotificationManager.error('No existen datos');
        }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });
  };
  //======================================================     
  imprimir =(id_certi)=>{
    let fileURL = process.env.REACT_APP_API_URL  + 'certificado_reciboPDF/'+ id_certi;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }
  //-----------------------------------------------------------------
  nuevo = () => {
    let materia = this.props.store.materia
    let user = this.props.store.user

    this.modalRef.current.nuevo(user.id_peri, materia.id_mate, materia.nombre);
  }
  //-----------------------------------------------------------------
  editar = (item) =>{
    console.log('editar');
    //    console.log(item);
    let idd = item.id_tema;
    this.modalRef.current.editar(idd);
  }
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar');
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        let idd = item.id_carre;
        this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data();
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //-------------------------------------
  render() {
  
    return (
      <div>

        <div className='content'>

          {/*{/*--- -----------------------------*/}
          <div className='row'>
            <div className='col-md-12'>
              <h3> Lista de temas

              </h3>


              <div className='box box-info'>
                {/*-- box-header --*/}
                <div className='box-body pad'>

                  <form onSubmit={this.handleSubmit}>

                    <div className='row'>

                      <div className='col-md-4'>
                        <div className='form-group'>
                          <label className='control-label'>Busqueda:</label>
                          <input
                            type='text'
                            name='name'
                            onChange={this.handleChangeForm}
                            className='form-control input-sm' />
                        </div>
                      </div>

                      <div className='col-md-2'>
                        <button type='submit' style={{ marginTop: '24px' }} className='btn btn-success '>
                          <i className='fa fa-binoculars'></i> Buscar</button>

                      </div>

                    </div>
                  </form>

                </div>
                {/* box-body */}
              </div>


              {/*-- box table */}
              <div className='box'>

                <div className='box-body'>
                  <div className='top_title2'>
                    <div className='row'>
                      <div className='col-md-12'>


                        <div className=' pull-right'>

                          <Button onClick={() => this.nuevo()}
                            className='create-modal btn btn-info ' >
                            <i className='fa fa-plus'></i> Nuevo
                          </Button>
                        </div>
                        <h4>carrera</h4>
                      </div>
                    </div>
                  </div>
                  {/*-- */}
                  <table className='table table-striped table-hover' width='100%' align='center'>
                    <thead>

                      <tr>
                        <th>Cod. tema</th>
                        <th>Titulo</th>
                        <th>Concluido</th>

                        <th>Acción</th>
                      </tr>

                    </thead>
                    <tbody>
                      {/* className='text-left' */}

                      {this.state.data.map((item, index) => (
                        <tr key={index}>
                          <td>{item.id_tema}</td>
                          <td>{item.titulo }</td>
                          <td>{item.concluido_sn}</td>

                          <td>
                            <div className='btn-group'>
                              <Button className='btn btn-warning btn-sm' title='Editar'
                                onClick={() => this.editar(item)}>
                                <i className='fa fa-edit'></i>
                              </Button>
                              &nbsp;
                              <Button className='btn btn-danger btn-sm' title='Eliminar'
                                onClick={() => this.eliminar(item)}  >
                                <i className='fa fa-trash'></i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}



                    </tbody>
                  </table>
                  {/*-- */}
                </div>


                <ModalTema
                  ref={this.modalRef}
                  okModal={this.okModal}
                  closeModal={this.closeModal}
                />

              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
        <NuConfirm ref={this.refNuConfirm} />
      </div>
    );
  }
}
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(TemaList);
